import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} ObservationReportReviewPageNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {ObservationReportReviewPageNotificationProps} props
 */
const ObservationReportReviewPageNotification = props => {
  const { notification } = props;

  const redirectUrl = pageUrlService.getObservationReportReviewPageUrl(
    notification.ObservationReportId
  );

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label={`New Observation Report for ${notification.ObservedUser.FullName} is ready for submission.`}
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default ObservationReportReviewPageNotification;
